// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Z_s"};